import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32, FctValue } from '../../../../Fct/generics';
import { FaFileAlt } from 'react-icons/fa';
import { secureStorageAddresses } from '../helpers/constants';
export var Read_uint256 = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'GETTER',
    method: 'read_uint256',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    owner: new FctAddress({ isPreview: true }),
                    key: new FctBytes32({ messageType: 'stringOrBytes32', isPreview: true, icon: FaFileAlt }),
                },
            },
            output: {
                value: new FctValue({ isPreview: true }),
            },
        });
    },
});
